"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _internals_1 = require("../_internals");
const union_1 = __importDefault(require("./union"));
const show_1 = __importDefault(require("./show"));
const enum_1 = __importDefault(require("./enum"));
const eq_1 = __importDefault(require("./eq"));
const ord_1 = __importDefault(require("./ord"));
const functor_1 = __importDefault(require("./functor"));
const tap_1 = __importDefault(require("./tap"));
const boxedEnum_1 = __importDefault(require("./boxedEnum"));
/**
 * Creates an enum type that can contain a value.
 * Implements Eq, Ord, Enum, Functor, Tap, BoxedEnum and Show
 * @param {*} name
 * @param {*} rawCases
 * @returns
 */
const BoxedEnumType = (name, rawCases) => {
    return (0, union_1.default)(name, rawCases.reduce((acc, next) => (0, _internals_1.assoc)(next, _internals_1.identity, acc), {}), [
        (0, eq_1.default)({ trivials: rawCases }),
        (0, ord_1.default)({ order: rawCases }),
        (0, enum_1.default)({ order: rawCases }),
        (0, functor_1.default)({ trivials: rawCases }),
        (0, tap_1.default)({ trivials: rawCases }),
        (0, show_1.default)({}),
        (0, boxedEnum_1.default)()
    ]).constructors({});
};
exports.default = BoxedEnumType;
